import { render, staticRenderFns } from "./notification-center.vue?vue&type=template&id=5df71c08&scoped=true&"
import script from "./notification-center.vue?vue&type=script&lang=js&"
export * from "./notification-center.vue?vue&type=script&lang=js&"
import style0 from "./notification-center.vue?vue&type=style&index=0&id=5df71c08&prod&lang=scss&"
import style1 from "./notification-center.vue?vue&type=style&index=1&id=5df71c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df71c08",
  null
  
)

export default component.exports